"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcoupon = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 61 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcoupon` : '') + (description ? ` desc-brandedcoupon` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcoupon"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcoupon"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.39 6.58a2.02 2.02 0 1 0 3.8-1.39l10.47-3.8c2.1-.77 4.42.31 5.19 2.42l8.65 23.78a4.05 4.05 0 0 1-2.42 5.19l-10.46 3.8a2.02 2.02 0 1 0-3.8 1.4L15.21 48a4.05 4.05 0 0 1-5.18-2.42L1.38 21.81a4.05 4.05 0 0 1 2.42-5.19L31.4 6.58Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.7 17.1c0 1.14.9 2.06 2.03 2.06 1.12 0 2.03-.92 2.03-2.05h11.18A4.09 4.09 0 0 1 61 21.2v25.7a4.09 4.09 0 0 1-4.06 4.11H45.76c0-1.13-.9-2.05-2.03-2.05-1.12 0-2.03.92-2.03 2.05H12.24a4.09 4.09 0 0 1-4.07-4.1V21.2c0-2.26 1.82-4.1 4.07-4.1H41.7Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56.94 17.1A4.09 4.09 0 0 1 61 21.22V46.9a4.09 4.09 0 0 1-4.06 4.11H45.76c0-1.13-.9-2.05-2.03-2.05-1.12 0-2.03.92-2.03 2.05H12.4a4.04 4.04 0 0 1-2.88-1.2l-.33-.34s18.21-7.19 29.97-16.43C50.89 23.8 55.19 17.13 55.2 17.1h1.73Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "48.8391",
    y: "27.9125",
    width: "8.97045",
    height: "1.99343",
    rx: "0.996717",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "48.8391",
    y: "31.8999",
    width: "8.97045",
    height: "1.99343",
    rx: "0.996717",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "48.8391",
    y: "35.8875",
    width: "8.97045",
    height: "1.99343",
    rx: "0.996717",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "48.8391",
    y: "39.8749",
    width: "8.97045",
    height: "1.99343",
    rx: "0.996717",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30 26h-5.07a2.9 2.9 0 0 0-2.07.88A3.03 3.03 0 0 0 22 29c0 4.5 8 4.5 8 9 0 .8-.3 1.56-.86 2.12a2.9 2.9 0 0 1-2.07.88H22",
    stroke: "#FFF5EB",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26 26v-3",
    stroke: "#FFF5EB",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26 41v4",
    stroke: "#FFF5EB",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var _default = exports.default = brandedcoupon;